import styles from '@/styles/hottest-deals/csotd.module.scss'
import { useState, useEffect } from 'react'
import { Timer } from '@/utils/countDown'
import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'

import Image from 'next/image'
import Link from 'next/link'

import MyTags from "@/components/MyTags"

import getConfig from 'next/config'
const { publicRuntimeConfig } = getConfig()
const imageDomain = publicRuntimeConfig.imageDomain
const inspectionModeEnabled = publicRuntimeConfig.inspectionModeEnabled === true
const strikethroughPriceVisible = publicRuntimeConfig.strikethroughPriceVisible === true

dayjs.extend(duration)

interface CsotdProps {
  productID: string;
  name: string;
  url: string;
  imgUrl: string;
  review: number;
  reviewCount: number;
  price: number;
  normalPrice: number;
  freeShipping: number;
  onSale: number;
  reduced: number;
  isNew: number;
  position?: number,
  location?: string;
  isEmailOnly: any,
  promotionTypeID: string | number;
  promotion: {
    productID: number;
    promotionType: number;
    promotionPrice: number;
    normalPrice: number;
    endDate: string;
    status: number;
    notified: number;
    pointRate: string;
    promotionRate: number;
  };
  crazyDeal: {
    hoursLeft: number;
    minutesLeft: number;
    secondsLeft: number;
  } | undefined
}

export default function CSOTD(props: CsotdProps) {

  // 检测是否为Firefox浏览器
  // const isFirefox = typeof window !== 'undefined' && window.navigator.userAgent.toLowerCase().includes('firefox');

  let timer = new Timer()
  interface TimeRemaining {
    days: number,
    hours: string,
    minutes: string,
    seconds: string,
    isEnd: boolean,
  }

  // 倒计时计算
  const [days, setDays] = useState(0)
  const [timeDetail, setTimeDetail] = useState<string[]>([])
  function countDown(times: Date | number) {
    timer.countDown(times, (timeRemaining: TimeRemaining) => {
      if (timeRemaining.isEnd) { // 倒计时结束了
        if (props.promotion.promotionType == 1) {
          location.reload()
        }
      } else { // 正在倒计时
        let timeDetail: string[] = []
        const { days, hours, minutes, seconds, isEnd } = timeRemaining
        if (isEnd) return
        let hh: string | number = days * 24 + parseInt(hours)
        if (hh <= 99) {
          hh < 10 ? hh = '0' + hh : hh = `${hh}`
          const [h1, h2] = hh.split('')
          timeDetail.push(h1, h2)
        } else {
          timeDetail.push('9', '9')
        }
        const [m1, m2] = minutes.split('')
        const [s1, s2] = seconds.split('')
        timeDetail = [...timeDetail, m1, m2, s1, s2]
        setTimeDetail(timeDetail)
      }
    })
  }

  useEffect(() => {
    if (inspectionModeEnabled) return

    // csotd, 从数据返回拿
    if (
      props.promotion.promotionType == 1
      && (props.crazyDeal?.hoursLeft || props.crazyDeal?.minutesLeft || props.crazyDeal?.secondsLeft)
    ) {
      setDays(days)
      // 结束时间
      const time = new Date().getTime() + (60 * 60 * props.crazyDeal.hoursLeft + 60 * props.crazyDeal.minutesLeft + props.crazyDeal.secondsLeft) * 1000
      countDown(time)
    }
  }, [])

  let price = `${Number(props.normalPrice).toFixed(2)}`.split('.')
  if (props.price && props.price != props.normalPrice) {
    price = `${Number(props.price).toFixed(2)}`.split('.')
  }

  return (
    <>
      <Link href={props.url} legacyBehavior>
        <a className={styles['csotd-box']}>
          <div>
            {!inspectionModeEnabled && <div className={styles['count-down-box']}>
              <Image
                className={styles['count-down-banner']}
                src={`${imageDomain}/hottest-deals/csotd-banner.jpg`}
                alt={'banner'}
                width={714}
                height={100}></Image>

              <div className={styles['count-down-text']}>
                <div 
                  className={styles['count-item']}
                  style={{ 
                    background: `url('${imageDomain}/hottest-deals/count-item-bg.png') no-repeat`,
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center'
                    }}
                >
                  {timeDetail[0]}
                  <div className={styles['split-line']}></div>
                </div>

                <div 
                  className={styles['count-item']}
                  style={{ 
                    background: `url('${imageDomain}/hottest-deals/count-item-bg.png') no-repeat`,
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center'
                    }}
                >
                  {timeDetail[1]}
                  <div className={styles['split-line']}></div>
                </div>

                <div 
                  className={styles['count-item']}
                  style={{ 
                    background: `url('${imageDomain}/hottest-deals/count-item-bg.png') no-repeat`,
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    marginLeft: '14px'
                    }}
                >
                  {timeDetail[2]}
                  <div className={styles['split-line']}></div>
                </div>

                <div 
                  className={styles['count-item']}
                  style={{ 
                    background: `url('${imageDomain}/hottest-deals/count-item-bg.png') no-repeat`,
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center'
                    }}
                >
                  {timeDetail[3]}
                  <div className={styles['split-line']}></div>
                </div>

                <div 
                  className={styles['count-item']}
                  style={{ 
                    background: `url('${imageDomain}/hottest-deals/count-item-bg.png') no-repeat`,
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    marginLeft: '14px'
                    }}
                >
                  {timeDetail[4]}
                  <div className={styles['split-line']}></div>
                </div>

                <div 
                  className={styles['count-item']}
                  style={{ 
                    background: `url('${imageDomain}/hottest-deals/count-item-bg.png') no-repeat`,
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center'
                    }}
                >
                  {timeDetail[5]}
                  <div className={styles['split-line']}></div>
                </div>
              </div>
            </div>}

            <div className={styles['product-box']} style={inspectionModeEnabled ? { paddingTop: '24px', paddingBottom: '94px' } : {}}>
              <div className={styles['product-image-box']}>
                <Image
                  className={styles['count-down-banner']}
                  src={props.imgUrl}
                  alt={props.name}
                  priority={true}
                  width={240}
                  height={240}></Image>

                {
                  !inspectionModeEnabled && (props?.promotion.promotionRate)
                  &&
                  <div className={styles['promotion-rate-box']}>
                    <div className={styles['promotion-rate']}>{props.promotion?.promotionRate}</div>
                    <div className={styles['promotion-unit']}>
                      <div className={styles['promotion-rate-sign']}>%</div>
                      <div className={styles['promotion-rate-text']}>OFF</div>
                    </div>
                  </div>
                }
              </div>
              <div className={styles['product-info']}>
                <div className={styles['product-name']}>{props.name}</div>
                {!inspectionModeEnabled && <MyTags {...props} />}

                {!inspectionModeEnabled && <div className={styles['price-title']}>Crazy Price:</div>}
                <div className={styles['price-info']}>
                  <div className={styles['promotion-price']}>
                    $<b>{price[0]}<i>.{price.length === 2 ? price[1] : '00'}</i></b>
                  </div>

                  {strikethroughPriceVisible && <div className={styles['normal-price']}>Was:${props.normalPrice}</div>}
                </div>

                <div className={styles['buy-now-btn']}>Buy Now</div>
              </div>
            </div>
          </div>
        </a>
      </Link>
    </>
  )
}
